import { roomEvents } from "@closerplatform/closer-sdk";
import { ID } from "@closerplatform/closer-sdk/dist/protocol/protocol";
import { logger } from "@fidget/common/utils";
import { ICoreRoom } from "../Room";
import { roomEventToChatItemSnapshot } from "../utils";

export const artichokeEventsRoomListener = (self: ICoreRoom) => {
  const onRoomMessageReceived = (message: roomEvents.MessageSent) => {
    self.udpateFromChatMessage(message);
    onMessage(message);
  };

  const onRoomCustomMessageReceived = (message: roomEvents.CustomMessageSent) => {
    self.udpateFromChatCustomMessage(message);
    onMessage(message);
  };

  const onMessage = (message: roomEvents.MessageSent | roomEvents.CustomMessageSent) => {
    self.removeTypingUser(message.authorId);
    if (message.authorId !== self.currentUserStore.id) {
      self.artichokeService.setDelivery(message.roomId, message.messageId);
    }

    roomEventToChatItemSnapshot(message, self.spinnerService)
      .then((item) => {
        self.chat.addChatItems(item);

        if (
          self.isChatFocusedOnMostRecent &&
          message.authorId === self.currentUserStore.id &&
          self.id === message.roomId
        ) {
          self.artichokeService.setMark(message.roomId, message.timestamp);
        }
      })
      .catch((e) => {
        logger.error({ message: "Couldn't add chat item on artichoke message", error: e });
      });
  };

  const onRoomMessageUpdated = (data: roomEvents.MessageUpdated) => {
    if (self.id === data.roomId) {
      self.chat.updateMessage(data.messageId, data.authorId, data.context);
    }
  };

  const onRoomChatMarked = (user: ID, mark: number) => {
    self.chat.marks.put({ user, mark });
    if (self.owner.id === user && self.currentUserStore.id) {
      self.chat.setReadUntilMark(self.currentUserStore.id, mark);
    }
  };

  const onRoomTypingReceived = (event: roomEvents.TypingSent) => {
    if (self.isSelected && self.id === event.roomId) {
      const { authorId, preview: eventPreview } = event;

      const shouldDisplayPreview = self.currentUserStore.orgConfig?.typingPreviewEnabled;
      const preview = shouldDisplayPreview ? eventPreview : undefined;

      self.updateTypingUser(authorId, preview);
    }
  };

  return {
    onRoomMessageReceived,
    onRoomCustomMessageReceived,
    onRoomMessageUpdated,
    onRoomChatMarked,
    onRoomTypingReceived
  };
};
